export default __webpack_public_path__ + "static/media/hht2_ep12_timeline_q01_b.64fefead.png";